import { action, computed, observable, toJS } from 'mobx'
import { persist } from 'mobx-persist'
import { User } from 'utilities'
import {
  CardsSettings,
  initialLayoutSettings,
  LayoutSettings,
  SectionLabels,
  StatsCards
} from './DashboardPageStore.types'
import { getOrderedSectionLabels } from './DashboardPageStore.utils'

export const DASHBOARD_PAGE_STORE = 'DASHBOARD_PAGE_STORE'

export class DashboardPageStore {
  @persist('object')
  @observable public layoutSettings: LayoutSettings = initialLayoutSettings

  @persist('object')
  @observable public cardsSettings: CardsSettings = {}

  @action private setLayoutSettings = (layoutSettings: LayoutSettings): void => {
    this.layoutSettings = layoutSettings
  }

  @action private setCardsSettings = (cardsSettings: CardsSettings): void => {
    this.cardsSettings = cardsSettings
  }

  public clearStore = () => {
    this.setLayoutSettings(initialLayoutSettings)
    this.setCardsSettings({})
  }

  public onLogin = () => {
    if (JSON.stringify(toJS(this.cardsSettings)) === '{}') {
      const cardsSettings: CardsSettings = User.areAllDashboardComponentsVisible
        ? {
          [StatsCards.PROJECTS]: { visible: true, position: 0 },
          [StatsCards.AGREEMENTS]: { visible: true, position: 1 },
          [StatsCards.PEOPLE]: { visible: true, position: 2 },
          [StatsCards.PRODUCTS]: { visible: true, position: 3 },
          [StatsCards.STORES]: { visible: true, position: 4 },
          [StatsCards.USERS]: { visible: true, position: 5 }
        }
        : {
          [StatsCards.PROJECTS]: { visible: true, position: 0 },
          [StatsCards.AGREEMENTS]: { visible: true, position: 1 },
          // [StatsCards.PEOPLE]: { visible: true, position: 2 },
          [StatsCards.PRODUCTS]: { visible: true, position: 2 },
          [StatsCards.STORES]: { visible: true, position: 3 },
          [StatsCards.USERS]: { visible: true, position: 4 }
        }
      this.setCardsSettings(cardsSettings)
    }
  }

  public onSaveLayoutClick = (
    layoutSettings: LayoutSettings,
    cardsSettings: CardsSettings
  ): void => {
    this.setLayoutSettings(layoutSettings)
    this.setCardsSettings(cardsSettings)
  }

  @computed public get orderedLayoutSectionLabels (): SectionLabels[] {
    return getOrderedSectionLabels<SectionLabels>(this.layoutSettings, {
      skipInvisible: true
    })
  }

  @computed public get orderedCardLabels (): StatsCards[] {
    return getOrderedSectionLabels<StatsCards>(this.cardsSettings, {
      skipInvisible: true
    })
  }
}
